export const FETCH_BUCKET = "FETCH_BUCKET";
export const UPDATE_BUCKET = "UPDATE_BUCKET";
export const CREATE_BUCKET = "CREATE_BUCKET";
export const DELETE_BUCKET = "DELETE_BUCKET";
